<template>
  <v-form v-model="valid">
    <v-card>
      <v-system-bar>Angaben</v-system-bar>
      <v-list>
        <v-list-item v-if="$_isAdminApp">
          <PersonInput
            v-model="item.employee"
            group="staff"
            label="Angestellte"
          />
        </v-list-item>

        <v-list-item>
          <CoursePartInput
            v-model="item.courses"
            multiple
            :items="item.courses"
            label="Kurse"
            :disabled="item.event != null"
          >
          </CoursePartInput>
        </v-list-item>
        <v-list-item> oder </v-list-item>
        <v-list-item>
          <v-autocomplete
            v-model="item.event"
            label="Anlass"
            item-text="description"
            return-object
            :items="events"
            :disabled="item.courses && item.courses.length > 0"
            :readonly="item.department != null"
          >
            <template v-slot:selection="data">
              <v-list-item-content style="flex-grow: 2">
                <v-list-item-title
                  v-html="data.item.description"
                ></v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.creator.code }}
                  <span
                    v-if="data.item.members && data.item.members.length > 0"
                  >
                    ({{ data.item.members.map((m) => m.code).join(", ") }})
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title
                  v-html="data.item.description"
                ></v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.creator.code }}
                  <span
                    v-if="data.item.members && data.item.members.length > 0"
                  >
                    ({{ data.item.members.map((m) => m.code).join(", ") }})
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-list-item>
        <v-list-item>
          <v-text-field
            ref="description"
            v-model="item.description"
            label="Bezeichnung"
            placeholder="z.B. «Lektüre: Le Petit Prince»"
            :rules="[rules.required]"
          ></v-text-field>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Erstellt am</v-list-item-subtitle>
            <v-list-item-title
              ><DateValue :value="item.date" long />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card class="mt-4">
      <v-system-bar>Konto</v-system-bar>
      <v-list>
        <v-list-item>
          <LookupValueInput
            :items="accounts"
            v-model="item.account"
            label="Konto"
            :rules="[rules.required]"
          />
        </v-list-item>

        <v-list-item
          v-if="
            item.account &&
            item.account.code === 'teachingMaterial' &&
            !item.department
          "
        >
          <GradesInput v-model="item.grades" />
        </v-list-item>

        <v-list-item v-if="item.account && item.account.code === 'fieldTrip'">
          <SchoolYearInput
            v-model="item.schoolYear"
            :range="[-1, 1]"
            label="Schuljahr"
          ></SchoolYearInput>
        </v-list-item>
        <v-list v-if="!gym1OK">
          <v-list-item>
            <v-alert type="error">
              Schüler:innen GYM2-4 können keine Rechnungen auf Stufe GYM1 haben!
            </v-alert>
          </v-list-item>
        </v-list>
      </v-list>
    </v-card>
    <v-card class="mt-4">
      <v-system-bar>Zahlung</v-system-bar>
      <v-list>
        <v-list-item>
          <LookupValueInput
            :items="payees"
            v-model="item.payee"
            label="Zahlung"
            :rules="[rules.required]"
          />
        </v-list-item>
        <v-list-item v-if="copies">
          <v-row no-gutters>
            <v-col>
              <v-list-item>
                <v-text-field
                  label="Kopien s/w pro Schüler*in"
                  @focus="$event.target.select()"
                  type="number"
                  min="0"
                  v-model="copiesGrayscale"
                ></v-text-field>
              </v-list-item>
            </v-col>
            <v-col>
              <v-list-item>
                <v-text-field
                  label="Kopien farbig pro Schüler*in"
                  @focus="$event.target.select()"
                  type="number"
                  min="0"
                  v-model="copiesColor"
                ></v-text-field>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list-item>
        <v-list-item v-if="copies">
          <v-list-item-content> Kosten pro Person</v-list-item-content>
          <v-list-item-action
            ><CurrencyValue v-model="copiesAmount" :currency="currency" />
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="employee">
          <v-text-field
            ref="iban"
            v-model="item.iban"
            label="IBAN"
            :rules="[rules.iban]"
          >
            <template v-slot:append-outer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon @click="fillIban"
                    ><v-icon>mdi-import</v-icon></v-btn
                  >
                </template>
                <span>IBAN aus Einstellungen einfügen</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-list-item>
      </v-list>
      <v-divider v-if="copies" />
      <v-card-actions v-if="copies"
        ><v-spacer /><v-btn text @click="assign">Zuweisen</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-4">
      <v-system-bar>Betrag</v-system-bar>

      <InvoiceAmount
        v-model="item"
        @updateTolerance="updateTolerance"
        :localonly="copies || employee || item.department != null"
        :nodetails="item.nodetails"
      />
      <v-divider />
      <v-list v-if="foreign">
        <v-list-item>
          <v-alert type="info">
            Rechnung in Fremdwährung. Der genaue Wechselkurs wird bei der
            Zahlung ermittelt.
          </v-alert>
        </v-list-item>
      </v-list>
      <v-list v-if="!mixedGradesOK">
        <v-list-item>
          <v-alert type="error">
            Schüler:innen GYM1 und GYM2-4 können nicht gemischt werden!
          </v-alert>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-btn
          text
          @click="distribute"
          :disabled="
            !item ||
            (!item.amount && !item.amountForeign) ||
            !item.details.length
          "
          >gleichmässig verteilen</v-btn
        >
        <v-spacer />
        <FinanceInvoiceSave
          v-if="!$_isAdminApp"
          :item="item"
          @saved="(newId) => $emit('saved', newId)"
          :tolerance="tolerance"
          :valid="valid"
        />
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { defineComponent } from "vue";
import CoursePartInput from "common/components/CoursePartInput.vue";
import CurrencyInput from "common/components/CurrencyInput.vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import DateValue from "common/components/DateValue.vue";
import FinanceInvoiceSave from "common/components/Finance/FinanceInvoiceSave.vue";
import GradesInput from "common/components/GradesInput.vue";
import InvoiceAmount from "common/components/Finance/InvoiceAmount.vue";
import LookupValueInput from "common/components/LookupValueInput.vue";
import PersonInput from "common/components/PersonInput.vue";
import PersonChip from "common/components/PersonChip.vue";
import PersonItemBasic from "common/components/PersonItemBasic.vue";
import PersonCoursePicker from "common/components/Finance/PersonCoursePicker.vue";
import PersonEventPicker from "common/components/Finance/PersonEventPicker.vue";
import PersonPicker from "common/components/Finance/PersonPicker.vue";
import SchoolYearInput from "common/components/SchoolYearInput.vue";

import { today } from "common/utils/date.js";
import {
  createInvoice,
  foreign,
  gym1OK,
  mixedGradesOK,
  isValidIBANNumber,
  getIban,
} from "common/utils/finance.js";

export default defineComponent({
  components: {
    CoursePartInput,
    CurrencyInput,
    CurrencyValue,
    DateValue,
    FinanceInvoiceSave,
    GradesInput,
    InvoiceAmount,
    LookupValueInput,
    PersonChip,
    PersonInput,
    PersonCoursePicker,
    PersonEventPicker,
    PersonItemBasic,

    PersonPicker,
    SchoolYearInput,
  },
  props: {
    value: {},
  },
  data() {
    return {
      accounts: [],
      copiesColor: 0,
      copiesGrayscale: 0,
      events: [],
      loading: false,
      saving: false,
      item: createInvoice(),
      priceGrayscale: 10,
      priceColor: 35,
      payees: [],
      rules: {
        required: (value) => !!value || "wird benötigt.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        iban: (value) => {
          return isValidIBANNumber(value) || "Ungültige IBAN.";
        },
      },

      searchSchoolClass: "",
      searchName: "",
      sortOption: "schoolClass",
      tolerance: true,
      valid: false,
    };
  },
  computed: {
    currency() {
      if (!this.item) return false;
      return this.item.currency ? this.item.currency.code : "CHF";
    },
    foreign() {
      return foreign(this.item);
    },
    gym1OK() {
      return gym1OK(this.item);
    },
    mixedGradesOK() {
      return mixedGradesOK(this.item);
    },
    copies() {
      return this.item.payee && this.item.payee.code == "schoolFund";
    },
    copiesAmount() {
      return (
        (this.priceGrayscale * this.copiesGrayscale +
          this.priceColor * this.copiesColor) /
        100
      );
    },
    employee() {
      return this.item.payee && this.item.payee.code == "employee";
    },
    isNew() {
      return !this.id;
    },
  },
  watch: {
    copies() {
      if (this.copies) {
        this.item.currency = { id: 1, local: true };
      }
    },
    employee() {
      if (this.employee) {
        this.item.currency = { id: 1, local: true };
      }
    },
    "item.department"(newVal) {
      if (newVal) {
        this.item.event = "Fachschaft " + this.item.department;
      }
    },
    item: {
      handler() {
        if (this.item.payee && this.item.payee.code == "schoolFund") {
          // this.item.amount = 0;
          this.item.amountForeign = 0;
        }
        this.$emit("input", this.item);
      },
      deep: true,
    },
    value() {
      this.item = this.value;
    },
    valid() {
      this.$emit("valid", this.valid);
    },
  },
  methods: {
    async fillIban() {
      this.item.iban = await getIban();
    },
    assign() {
      this.item.details.forEach(
        (detail) => (detail.amount = this.copiesAmount)
      );

      this.item.amount = this.copiesAmount * this.item.details.length;
    },
    distribute() {
      const details = this.item.details;
      if (this.foreign) {
        const amountForeign =
          Math.floor((100 * this.item.amountForeign) / details.length) / 100;
        details.forEach((detail) => (detail.amountForeign = amountForeign));
      } else {
        const amount =
          Math.floor((100 * this.item.amount) / details.length) / 100;
        details.forEach((detail) => (detail.amount = amount));
      }
    },
    updateTolerance(tolerance) {
      this.tolerance = tolerance;
    },
  },
  async created() {
    this.item = this.value;
    this.item.date = today();
    this.loading = true;

    this.accounts = await this.apiList({
      resource: "finance/invoiceaccount?course",
    });

    if (
      (this.item && this.item.employee && this.item.employee.id) ||
      this.$_profilePerson
    ) {
      this.events = await this.apiList({
        resource: "finance/invoiceevent",
      });
    }

    this.payees = await this.apiList({ resource: "finance/payee" });

    this.loading = false;
  },
});
</script>
